
if (typeof TPS === "undefined" || !TPS) {
    var TPS = {};
}

TPS.OSDLookup = {
    init: function () {
        this.Form.init();
        TPS.OSD.PageLoader.init();
    }
};

TPS.OSDLookup.Form = {
    // Global selectors
    formSearchWrapperSelector: '#tps-osd-lookup-search',
    formInfoWrapperSelector: '#tps-osd-lookup-orderinfo',
    fieldsSelector: 'input[type="text"], input[type="email"], input[type="hidden"], select, textarea',
    datepickerSelector: '#requestDeliveryDate',
    init: function () {
        this.datePicker();
        this.loadWebServices();
        this.Events.init();
        this.Validate.init();
    },
    loadWebServices: function () {
        TPS.Util.loadWebserviceJS('CMSApp.OSD.API.Order'); 
    },
    datePicker: function () {
        var self = this;
        var minDate = new Date(window.OSDrescheduleDateString_min);
        var maxDate = new Date(window.OSDrescheduleDateString_max);
        
        $(self.datepickerSelector).datepicker({
            dateFormat: 'mm/dd/yy',
            minDate: minDate,
            maxDate: maxDate
        });

    }
};

TPS.OSDLookup.Form.Validate = {
    validationMessages: {},
    formSearchErrorSelector: '#tps-osd-lookup-search-errors',
    formInfoErrorSelector: '#tps-osd-lookup-orderinfo-errors',
    init: function () {
        this.validationMessages = window.OSDLookupMessages;
    },
    removeError: function (el) {
        el.closest('.form-control-wrapper').removeClass('error');
    },
    // validate OSD search inputs
    isValidSearch: function (el) {
        var _this = TPS.OSDLookup.Form.Validate;

        var searchOrderNumber, searchOrderNumberVal, searchOrderEmail, searchOrderEmailVal, isValid;

        searchOrderNumber = $('#orderNumber');
        searchOrderNumberVal = searchOrderNumber.val();
        searchOrderEmail = $('#orderEmail');
        searchOrderEmailVal = searchOrderEmail.val();

        isValid = true;

        // clear any validation messages
        $(_this.formSearchErrorSelector).empty().hide();
        _this.removeError(searchOrderNumber);
        _this.removeError(searchOrderEmail);
        
        // Check that at least one of the fields has a value
        if (searchOrderNumberVal === '' && searchOrderEmailVal === '') {
            isValid = false;
            searchOrderNumber.closest('.form-control-wrapper').addClass('error');
            searchOrderEmail.closest('.form-control-wrapper').addClass('error');
            
            $(_this.formSearchErrorSelector).text(_this.validationMessages.validation.VALUEREQUIRED).show();
        }
        
        if (isValid) {
            // validate email address
            searchOrderEmail.each(function () {
                var val = $.trim($(this).val());
                if (val !== '' && !TPS.Util.validateEmail(val)) {
                    isValid = false;
                    $(this).closest('.form-control-wrapper').addClass('error');
                    $(_this.formSearchErrorSelector).text(_this.validationMessages.validation.VALUEREQUIRED).show();
                }
            });
        }

        return isValid;
    },
    isValidInfo: function (el) {
        var _this = TPS.OSDLookup.Form.Validate;
        var orderNumber, orderNumerVal, orderEmail, orderEmailVal, rescheduleOption, rescheduleOptionVal, rescheduleDateRequested, rescheduleDateRequestedVal, isValid;

        orderNumber = $('#rescheduleOrderNumber');
        orderNumerVal = orderNumber.val();
        rescheduleOption = $('[name="rescheduleOption"]:checked');
        rescheduleOptionVal = rescheduleOption.val();

        rescheduleDateRequested = $(TPS.OSDLookup.Form.datepickerSelector);
        rescheduleDateRequestedVal = rescheduleDateRequested.val();

        isValid = true;

        // clear any validation messages
        $(_this.formInfoErrorSelector).empty().hide();
        _this.removeError(rescheduleOption);

        if (orderNumerVal === '' || typeof orderNumerVal === 'undefined' || rescheduleOptionVal === '' || typeof rescheduleOptionVal === 'undefined') {
            isValid = false;
            $('[name="rescheduleOption"]').closest('.form-control-wrapper').addClass('error');

            $(_this.formInfoErrorSelector).text(_this.validationMessages.reschedule.VALUEREQUIRED).show();
        }
        if (rescheduleOptionVal === '2' && (rescheduleDateRequestedVal === '' || typeof rescheduleDateRequestedVal === 'undefined') ) {
            isValid = false;
            rescheduleDateRequested.closest('.form-control-wrapper').addClass('error');

            $(_this.formInfoErrorSelector).text(_this.validationMessages.reschedule.SELECTADATE).show();
        }

        return isValid;

    }
};

TPS.OSDLookup.Form.Events = {
    formSearchButtonSelector: '#tps-osd-lookup-search-submit',
    formInfoButtonSelector: '#tps-osd-lookup-orderinfo-submit',
    formInfoSuccessSelector: '#tps-osd-lookup-orderinfo-success',

    init: function () {
        this.onShowHideFormSections();
        this.onSubmitSearchClick();
        this.onSubmitInfoClick();
    },
    onSubmitSearchClick: function () {
        var _this = this;
        var _form = TPS.OSDLookup.Form;
        var _validateObj = TPS.OSDLookup.Form.Validate;
        var _formErrorElem = $(_validateObj.formSearchErrorSelector);
        $(document).on('click', _this.formSearchButtonSelector, function (e) {
            e.preventDefault();
            TPS.OSDLookup.OrderInfo.resetOrderDetails();
            var isValid = _form.Validate.isValidSearch(this);
            if (isValid) {

                TPS.OSD.PageLoader.show();
                
                CMSApp.OSD.API.Order.GetOrderByNumberEmail(
                    $('#orderNumber').val(),
                    $('#orderEmail').val(),
                    function (data) {
                        if (data.Success) {
                            TPS.OSDLookup.OrderInfo.populateOrderDetails(data.ObjectVM);
                        } else {
                            _formErrorElem.text(_validateObj.validationMessages.search[data.Messages[0]]).show();
                            TPS.OSD.PageLoader.hide();
                        }
                    },
                    function () {
                        _formErrorElem.text(_validateObj.validationMessages.search.GENERICERROR).show();
                        TPS.OSD.PageLoader.hide();
                    }
                );
            }
        });
    },
    onSubmitInfoClick: function () {
        var _this = this;
        var _form = TPS.OSDLookup.Form;
        var _validateObj = TPS.OSDLookup.Form.Validate;
        var _formErrorElem = $(_validateObj.formInfoErrorSelector);
        $(document).on('click', _this.formInfoButtonSelector, function (e) {
            e.preventDefault();
            var isValid = _form.Validate.isValidInfo(this);
            if (isValid) {
                TPS.OSD.PageLoader.show();
                var orderNumberVal = $('#rescheduleOrderNumber').val();
                var reschduleOptionVal = $('[name="rescheduleOption"]:checked').val();
                var requestDeliveryDate = $(TPS.OSDLookup.Form.datepickerSelector).val();
                CMSApp.OSD.API.Order.SaveRescheduleOrder(
                    orderNumberVal,
                    reschduleOptionVal,
                    requestDeliveryDate,
                    function (data) {
                        if (data.Success) {
                            TPS.OSDLookup.OrderInfo.showSuccessMessage(data.ObjectVM);
                        } else {
                            _formErrorElem.text(_validateObj.validationMessages.reschedule[data.Messages[0]]).show();
                            TPS.OSD.PageLoader.hide();
                        }
                    },
                    function () {
                        _formErrorElem.text(_validateObj.validationMessages.reschedule.GENERICERROR).show();
                        TPS.OSD.PageLoader.hide();
                    }
                );
            }
        });
    },
    onShowHideFormSections: function () {
        TPS.SSA.Form.Events.onShowHideFormFields();
    }
};

TPS.OSDLookup.OrderInfo = {
    orderDetailsSelector: '#tps-osd-lookup-result',
    resetOrderDetails: function () {
        var _this = TPS.OSDLookup.OrderInfo;
        $(_this.orderDetailsSelector).fadeOut();
    },
    populateOrderDetails: function (data) {
        var _this = TPS.OSDLookup.OrderInfo;

        var _orderDeliveryCutoff = typeof window.OSDCutoffDateString !== 'undefined' && window.OSDCutoffDateString !== '' ? OSDCutoffDateString : false;
        // clear the order details
        TPS.Forms.clearFormFields(_this.orderDetailsSelector);
        // remove error classes
        $(_this.orderDetailsSelector).find('.form-control-wrapper').removeClass('error');
        $(TPS.OSDLookup.Form.Validate.formInfoErrorSelector).empty().hide();

        $('#BuyerFullName').val(data.Customer.BuyerFullName);
        $('#YearName').val(data.YearName);
        $('#ModelName').val(data.ModelName);
        $('#VehicleName').val(data.VehicleName);
        $('#OrderDate').val(data.OrderDate);
        $('#OrderDeliveryDate').val(data.OrderDeliveryDate);
        $('#RetailerName').val(data.RetailerName);
        $('#RetailerRepresentativeName').val(data.RetailerRepresentativeName);
        $('#RetailerPhone').val(data.RetailerPhone);
        $('#RetailerEmail').val(data.RetailerEmail);
        $('#rescheduleOrderEmail').val(data.Customer.Email);
        $('#rescheduleOrderNumber').val(data.VistaOrder);

        var _rescheduleAfterCutoff = $('#rescheduleAfterCutoff');
        var _rescheduleOption_legend = $('#rescheduleOption_legend');

        // cutoff & delivery date have values
        if (_orderDeliveryCutoff && typeof data.OrderDeliveryDate !== 'undefined') {
            var _orderDeliveryCutoff_obj = new Date(_orderDeliveryCutoff)
            var _orderDeliveryCutoff_string = window.OSDMonths[_orderDeliveryCutoff_obj.getMonth()] + ' ' + _orderDeliveryCutoff_obj.getDate() + ', ' + _orderDeliveryCutoff_obj.getFullYear();
            var _orderDeliveryDate_obj = new Date(data.OrderDeliveryDate);
            var validationObj = TPS.OSDLookup.Form.Validate;
            // delivery is before or equal the cutoff
            if (_orderDeliveryDate_obj <= _orderDeliveryCutoff_obj) {

                _rescheduleAfterCutoff.val('0').trigger('change');
                _rescheduleOption_legend.html($.parseHTML(validationObj.validationMessages.dates.BEFORECUTOFF.replace('{date}', _orderDeliveryCutoff_string)));

            }
            // delivery is after the cutoff
            else if (_orderDeliveryDate_obj > _orderDeliveryCutoff_obj) {

                _rescheduleAfterCutoff.val('1').trigger('change');
                _rescheduleOption_legend.html($.parseHTML(validationObj.validationMessages.dates.AFTERCUTOFF.replace('{date}', _orderDeliveryCutoff_string)));
            }

        }

        $(_this.orderDetailsSelector).fadeIn(function () {
            TPS.OSD.PageLoader.hide();
        });
    },
    showSuccessMessage: function (data) {
        var _this = TPS.OSDLookup.OrderInfo;
        var _form = TPS.OSDLookup.Form;
        var _orderDetailsElem = $(_this.orderDetailsSelector);
        _orderDetailsElem.fadeOut(function () {

            var _successElem = $(_form.Events.formInfoSuccessSelector);

            TPS.Forms.clearFormFields(_this.orderDetailsSelector);
            TPS.Forms.clearFormFields(_form.formSearchWrapperSelector);
            TPS.OSD.PageLoader.hide();
            _successElem.fadeIn(function () {
                _successElem.focus().delay(5000).fadeOut(function () {
                    $('#orderNumber').focus();
                });
            });

        });

    }
}
